import React from 'react'
import "../assets/pages-css/home.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from '../components/globals/home/footer';
import Copyright from '../components/globals/home/copyright';
import Header from '../components/globals/home/header';

const TermsOfService = () => {

  return (
    <>
       <Header />
      <div className='container mt-4 mb-4'>
        <h1>Terms of Service</h1>
        <p><strong>Effective Date:</strong> 01/08/23</p>

        <p>Welcome to SharkSkillz! These Terms of Service ("Terms") govern your access to and use of the SharkSkillz platform and services ("Services"). By accessing or using our Services, you agree to be bound by these Terms. Please read them carefully.</p>

        <h2>1. Acceptance of Terms</h2>
        <p>By accessing or using the Services, you agree to comply with and be bound by these Terms and our Privacy Policy. If you do not agree with any part of these Terms, you must not use our Services.</p>

        <h2>2. Changes to Terms</h2>
        <p>SharkSkillz reserves the right to modify or update these Terms at any time. We will provide notice of significant changes, and your continued use of the Services after any changes have been made constitutes your acceptance of the new Terms. Please review these Terms periodically for updates.</p>

        <h2>3. Eligibility</h2>
        <p>The Services are intended for users who are at least 7 years old. By using our Services, you represent and warrant that you are at least the minimum age required.</p>

        <h2>4. User Accounts</h2>
        <p>To access certain features of our Services, you may be required to create an account. You agree to provide accurate, current, and complete information during the registration process and to keep such information updated. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>

        <h2>5. Use of Services</h2>
        <p>You agree to use the Services solely for lawful purposes and in accordance with these Terms. You will not use the Services:</p>
        <ul>
          <li>To engage in any unlawful conduct or post any content that is illegal, harmful, or violates the rights of others.</li>
          <li>To transmit any viruses, malware, or other harmful software.</li>
          <li>To interfere with or disrupt the integrity or performance of the Services or any data contained therein.</li>
        </ul>

        <h2>6. Content Ownership and Rights</h2>
        <p>SharkSkillz and its licensors own all rights, titles, and interests in and to the Services, including all intellectual property rights. You may not modify, reproduce, distribute, or create derivative works based on any portion of the Services, unless explicitly permitted by SharkSkillz in writing.</p>

        <h2>7. User Content</h2>
        <p>You retain ownership of any content you submit, post, or display through the Services ("User Content"). By submitting User Content, you grant SharkSkillz a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and display such content in connection with providing the Services.</p>

        <h2>8. Termination</h2>
        <p>SharkSkillz reserves the right to suspend or terminate your access to the Services at any time, with or without notice, for any reason, including if we believe you have violated these Terms.</p>

        <h2>9. Disclaimers</h2>
        <p>The Services are provided on an "as is" and "as available" basis without warranties of any kind, either express or implied. SharkSkillz disclaims all warranties, including any implied warranties of merchantability, fitness for a particular purpose, or non-infringement.</p>

        <h2>10. Limitation of Liability</h2>
        <p>To the fullest extent permitted by law, SharkSkillz shall not be liable for any indirect, incidental, special, consequential or punitive damages, or any loss of profits or revenues, arising out of or related to your use of the Services.</p>

        <h2>11. Governing Law</h2>
        <p>These Terms shall be governed and construed in accordance with the laws of United Kingdom, without regard to its conflict of law provisions.</p>

        <h2>12. Contact Information</h2>
        <p>If you have any questions or concerns regarding these Terms, please contact us at <a href="mailto:skillz@sharkskillz.com">skillz@sharkskillz.com</a>.</p>

        <p>Thank you for choosing SharkSkillz! We hope you enjoy our Services.</p>
      </div>
      <Footer />
      <Copyright />
    </>
  )
}

export default TermsOfService;